import React, { useState } from "react";
import Stepper from "react-stepper-horizontal";
import Button from "../../sharedComponents/buttons/button";
import Lang from "../../../userPreferences/staticWords";
import PageOne from "./registerPageOne";
import PageTwo from "./registerPageTwo";
import PageThree from "./registerPageThree";
import { currentLanguage } from "../../../algorithms/storage";
import { englishDate, objToFormData } from "../../../algorithms";
import { register } from "./../../../API/store/actions/auth";
const StepperPage = ({ dropdownLists }) => {
  const [pages, setPages] = useState({ one: true, two: false, three: false });
  const [pageOneData, setPageOneData] = useState({});
  const [pageTwoData, setPageTwoData] = useState({});
  const [pageThreeData, setPageThreeData] = useState({});
  const [finished, setFinished] = useState(false);
  const pageRender = (pageNo) => {
    pageNo === 1
      ? setPages({ one: true, two: false, three: false })
      : pageNo === 2
      ? setPages({ one: false, two: true, three: false })
      : setPages({ one: false, two: false, three: true });
  };
  // const registerHandler = () => {
  //   const data = { ...pageOneData, ...pageTwoData, ...pageThreeData };
  //   setFinished(true);
  //   if (pageThreeData.four && pageThreeData.five && pageThreeData.six)
  //     alert(JSON.stringify(data));
  // };
  let steps = [...stepsFunction(pageRender)];
  return (
    <>
      <div className="container">
        <div className="col-lg-6 col-md-8 col-12 container">
          <Stepper
            steps={steps}
            activeStep={pages.one ? 1 : pages.two ? 2 : 3}
            activeColor={"#1A73E8"}
            completeBorderColor={"#1A73E8"}
            size={40}
            completeColor={"#C7DEFB"}
            activeBorderColor={"#CECECE"}
            defaultBorderStyle={"solid"}
            completeBorderStyle={"solid"}
            activeBorderStyle={"solid"}
            defaultBorderWidth={2}
            // defaultTitleColor={"#444444"}
            circleFontColor={"#000"}
            defaultTitleColor={"#656565"}
            completeTitleColor={"#1A73E8"}
            activeTitleColor={"#000000"}
            lineMarginOffset={1}
          ></Stepper>
        </div>
        <div className="d-flex flex-wrap justify-content-center  my-4">
          {pages.one ? (
            <PageOne
              setPages={setPages}
              pages={pages}
              setPageOneData={setPageOneData}
              pageOneData={pageOneData}
              dropdownLists={dropdownLists}
            />
          ) : pages.two ? (
            <PageTwo
              setPages={setPages}
              pages={pages}
              setPageTwoData={setPageTwoData}
              pageTwoData={pageTwoData}
              dropdownLists={dropdownLists}
            />
          ) : (
            <PageThree
              setPages={setPages}
              pages={pages}
              setPageThreeData={setPageThreeData}
              pageThreeData={pageThreeData}
              isFinished={finished}
              dropdownLists={dropdownLists}
            />
          )}
        </div>
        {pages.three ? (
          <div className="col-12 p-0 d-flex justify-content-center">
            <Button
              onClick={() =>
                registerHandler(
                  {
                    ...pageOneData,
                    ...pageTwoData,
                    ...pageThreeData,
                  },
                  setFinished,
                  dropdownLists.clientId
                )
              }
              buttonStyleType={"solid"}
              content={Lang.finish}
              containerStyle={"col-3 mx-3 mb-2"}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};
export default StepperPage;

const registerHandler = (data, setFinished, ClientId) => {
  data.attachment = data.attachment == "" ? [] : data.attachment;
  const newData = {
    FirstNameA: data.firstName,
    FirstNameE: data.firstName,
    LastNameA: data.lastName,
    LastNameE: data.lastName,
    MobileNumber: data.phoneOne,
    PhoneNumber: data.phoneTwo,
    Email: data.email,
    Address: data.address,
    PhotoFile: data.photo,
    Attachments: data.attachment,
    BirthDate: englishDate(data.brithDay),
    Town: data.town,
    CountryId: data.country,
    TitleId: data.title,
    NationalityId: data.nationality,
    GenderId: data.gender,
    ResearchAreaIDs: data.proessionalAreaOfResearch,
    PreferencesIDs: data.preferances,
    ProfessionalStatusId: data.professionalStatus,
    PostGraduate: data.education,
    Confidentiality: data.four,
    Participation: data.five,
    Independcy: data.six,
    ClientId,
  };
  let registerData = objToFormData(newData);
  setFinished(true);
  if (data.five && data.six) {
    register(registerData);
  }
};

const stepsFunction = (pageRender) => {
  return [
    { title: currentLanguage() },
    ...[
      {
        title:
          currentLanguage() == "ar"
            ? "البيانات الشخصية"
            : "personal information",
        onClick: () => {
          pageRender(1);
        },
      },
      {
        title:
          currentLanguage() == "ar"
            ? "البيانات العلمية"
            : "scientific information",
        onClick: () => {
          pageRender(2);
        },
      },
      {
        title:
          currentLanguage() == "ar"
            ? "البيانات التخصصية"
            : "specialization information",
        onClick: () => {
          pageRender(3);
        },
      },
    ],
  ];
};
